import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=0f9facaa&scoped=true"
import script from "./reply.vue?vue&type=script&lang=ts"
export * from "./reply.vue?vue&type=script&lang=ts"
import style0 from "./reply.vue?vue&type=style&index=0&id=0f9facaa&prod&lang=less"
import style1 from "./reply.vue?vue&type=style&index=1&id=0f9facaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9facaa",
  null
  
)

export default component.exports